<template>
<circle cx="8" cy="8" r="4.25" stroke="currentColor" stroke-width="1.5" fill="none"/>
<circle cx="8" cy="8" r="1.25" fill="currentColor"/>
<path d="M8 1V3.25M8 12.75V15M1 8H3.25M12.75 8H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</template>
